module.exports = __webpack_public_path__ + "img/44b0795.png";